"use client";

import { useState } from "react";
import { BookletDate } from "@/@types";
import Link from "next/link";
import { ROUTES } from "@/config/routes";
import { IconSprite } from "../common";

type Props = {
  bookletsDate: BookletDate;
};

export default function BookletsDateCard({ bookletsDate }: Props) {
  const [openYears, setOpenYears] = useState<{ [key: string]: boolean }>({});
  const [openMonths, setOpenMonths] = useState<{ [key: string]: boolean }>({});

  const toggleYear = (year: string) => {
    setOpenYears((prev) => ({
      ...prev,
      [year]: !prev[year],
    }));
  };
  const toggleMonth = (year: string, month: string) => {
    const key = `${year}-${month}`;
    setOpenMonths((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const monthNameToNumber = (monthName: string) => {
    const months = Array.from({ length: 12 }, (_, i) => 
      new Date(2000, i, 1).toLocaleString("es-ES", { month: "long" })
    );

    const index = months.findIndex(
      (m) => m.toLowerCase() === monthName.toLowerCase()
    );

    return index + 1;
  }

  return (
    <div>
      {Object.entries(bookletsDate).sort((a,b) => Number(b[0]) - Number(a[0])).map(([year, months]) => {
        const yearOpen = openYears[year];
        return (
          <div key={year} className="mb-2">
            <div>
              <button
                onClick={() => toggleYear(year)}
                className="w-full flex items-center justify-between bg-white border-grey border-b-2 p-2 text-gray-700 hover:bg-gray-100 focus:outline-none"
              >
                <span>{year}</span>
                <IconSprite id="ic_arrow_down" className={`${yearOpen ? 'rotate-180' : ''} w-3 h-3`} />
              </button>
              {yearOpen && (
                <div className="ml-2">
                  {Object.entries(months).sort((a,b) => monthNameToNumber(b[0]) - monthNameToNumber(a[0])).map(([month, booklets]) => {
                    const key = `${year}-${month}`;
                    const monthOpen = openMonths[key];
                    
                    return (
                      <div key={key}>
                        <button
                          onClick={() => toggleMonth(year, month)}
                          className="w-full flex items-center justify-between bg-white border-grey border-b-2 p-2 text-gray-700 hover:bg-gray-100 focus:outline-none"
                        >
                          <span>{month}</span>
                          <IconSprite id="ic_arrow_down" className={`${monthOpen ? 'rotate-180' : ''} w-3 h-3`} />
                        </button>
                        {monthOpen && (
                          <div className="ml-2">
                            {booklets.map((booklet, index) => (
                              <Link
                                key={index}
                                href={ROUTES.literature.details(
                                  booklet.category_slug,
                                  booklet.slug
                                )}
                                className="w-full flex items-center justify-between bg-white border-grey border-b-2 p-2 text-gray-700 hover:bg-gray-100 focus:outline-none"
                              >
                                {booklet.title}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
